import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AdvancedFilter } from 'src/app/sharedModule/models/advanced-filter.model';
import { AdvancedFiltersManageSide } from '../advanced-filters-manage-side/advanced-filters-manage-side';
import { MatMenuTrigger } from '@angular/material/menu';
import { Observable, Subscription } from 'rxjs';

export const DEFAULT_ADVANCED_FILTER = 'ready';

@Component({
  selector: 'app-advanced-filters',
  templateUrl: './advanced-filters.component.html',
  styleUrls: ['./advanced-filters.component.scss'],
  standalone: false,
})
export class AdvancedFiltersComponent implements OnInit, OnDestroy {
  MAX_CHARS = 16;
  @ViewChild('drawer') drawer;
  @ViewChild('matTrigger') matTrigger: MatMenuTrigger;
  @ViewChild(AdvancedFiltersManageSide) manage: AdvancedFiltersManageSide;
  @Input() activeAdvancedFilter: string | number;
  @Input() advancedFilters$: Observable<any>;
  @Output() changeFilter = new EventEmitter<string | AdvancedFilter | any[]>();
  @Output() onClearAdvancedFilter = new EventEmitter<void>();
  @Input() disable: boolean = false;
  @Input() shopId: number;
  @Input() isTrialMode: boolean = false;

  private onUpdateAdvancedFiltersSubscription$: Subscription;

  advancedFilters: AdvancedFilter[];
  selectedActiveFilters: AdvancedFilter[] = [];
  positionTop;
  sideBarHeight = 'calc(100vh - 54px)';
  moveToManage: boolean;
  addNewFilter: boolean = false;
  checkedFilter: boolean = false;
  changeStyleStatus: boolean = false;
  addFirstFilter: boolean = false;
  pinnedArray: AdvancedFilter[] = [];
  regularAdvancedFilterArray: AdvancedFilter[];
  copyAdvancedFilters: AdvancedFilter[];
  saveDetect: boolean = false;
  localStoragePinnedArrayKey;
  localStoragePriorityUnPinnedArrayKey;
  constructor() {}

  ngOnInit() {
    this.localStoragePinnedArrayKey = `pinned-filters-${this.shopId}`;
    this.localStoragePriorityUnPinnedArrayKey = `priority-filters-${this.shopId}`;
    this.positionTop = this.getPositionTop(this.isTrialMode);
    this.loadPinnedFilters();
  }

  getPositionTop(isTrialMode) {
    return isTrialMode ? 90 : 54;
  }

  closeAdvancedFilter(advancedFilter: AdvancedFilter): void {
    this.selectedActiveFilters = this.selectedActiveFilters.filter((filter) => filter.id !== advancedFilter.id);
    this.changeFilter.emit(this.selectedActiveFilters);
  }

  loadPinnedFilters(): void {
    this.advancedFilters$.subscribe((filters) => {
      if (filters) {
        if (this.advancedFilters?.length !== filters?.length || this.advancedFilters == undefined || this.saveDetect) {
          this.advancedFilters = filters;
          this.copyAdvancedFilters = this.advancedFilters;
          this.pinnedArray = JSON.parse(localStorage.getItem(this.localStoragePinnedArrayKey)) ?? [];
          this.pinnedArray.forEach((pinnedFilter) => {
            this.copyAdvancedFilters = this.copyAdvancedFilters.filter((obj) => {
              return obj.id !== pinnedFilter.id;
            });
          });
          if (this.saveDetect) {
            this.pinnedArray = this.pinnedArrayChangeDetect(this.pinnedArray);
          }
          const priorityArray = JSON.parse(localStorage.getItem(this.localStoragePriorityUnPinnedArrayKey)) ?? [];
          if (priorityArray.length) {
            this.copyAdvancedFilters = this.copyAdvancedFilters
              .slice()
              .sort((x, y) => priorityArray.indexOf(x.id) - priorityArray.indexOf(y.id));
          }
          this.regularAdvancedFilterArray = this.copyAdvancedFilters;
          // this.onClearAll(undefined);
          this.saveDetect = false;
        }
      }
    });
  }

  onPinnedRow(event, advancedFilter: AdvancedFilter): void {
    event.stopPropagation();
    this.onClearAll(event);
    this.manage.onPinnedRow(event, advancedFilter);
  }

  onUnPinnedRow(event, advancedFilter: AdvancedFilter): void {
    event.stopPropagation();
    this.onClearAll(event);
    this.manage.onUnPinnedRow(event, advancedFilter);
  }

  //change the localstorage if filters saved\edited
  pinnedArrayChangeDetect(pinnedArray: AdvancedFilter[]): AdvancedFilter[] {
    let refreshedFilter: any;
    const tempPinnedArray: AdvancedFilter[] = [];
    localStorage.removeItem(this.localStoragePinnedArrayKey);
    pinnedArray.forEach((pinnedFilter) => {
      refreshedFilter = this.advancedFilters.find((filter) => filter.id == pinnedFilter.id);
      tempPinnedArray.push(refreshedFilter);
    });
    localStorage.setItem(this.localStoragePinnedArrayKey, JSON.stringify(tempPinnedArray));
    return tempPinnedArray;
  }

  onChangeFilter({ value }): void {
    this.selectedActiveFilters = [];
    this.selectedActiveFilters = value;
    this.changeFilter.emit(this.selectedActiveFilters);
  }

  clearThisFilter(event): void {
    event?.stopPropagation();
    this.onClearAdvancedFilter.emit(event);
    this.selectedActiveFilters = undefined;
  }

  resetSelectedFilters(): void {
    this.selectedActiveFilters = undefined;
  }

  onOpenDeleteAdvancedFilterDialog(
    event,
    advancedFilterId: number,
    advancedFilterName: string,
    advancedFilter: AdvancedFilter,
  ): void {
    event.stopPropagation();
    this.manage.onDeleteFilter(event, advancedFilterId, advancedFilterName, advancedFilter);
    this.selectedActiveFilters = undefined;
  }

  onClearAll(event?): void {
    this.clearThisFilter(event);
  }

  onSelectedFilters(event): void {
    this.selectedActiveFilters = event;
    this.changeFilter.emit(this.selectedActiveFilters);
  }

  onAdvancedFiltersArrayAction(filters: AdvancedFilter[]): void {
    this.regularAdvancedFilterArray = filters;
  }

  onPinnedArrayAction(filters: AdvancedFilter[]): void {
    this.pinnedArray = filters;
  }

  onSaveDetect($event): void {
    this.saveDetect = $event;
  }

  onOpenAddAdvancedFilterDialog(event, advancedFilter: AdvancedFilter = null): void {
    event.stopPropagation();
    this.closeMatMenu();
    this.drawer.toggle();
    this.manage.onLoadAdvancedFilter(event, advancedFilter, true);
  }

  onAddFilterManageSide(): void {
    this.advancedFilters?.length == 0 ? (this.advancedFilters = undefined) : this.advancedFilters;
    this.drawer.toggle();
    this.manage.divToggle('addFilter');
  }

  openManageSidePanel(): void {
    this.advancedFilters?.length == 0 ? (this.advancedFilters = undefined) : this.advancedFilters;
    this.drawer.toggle();
    this.advancedFilters ? this.manage.divToggle('manage') : this.manage.divToggle('addFirstFilter');
  }

  closeMatMenu(): void {
    this.matTrigger.closeMenu();
  }

  stringLengthConcat(string: string) {
    return string?.length > this.MAX_CHARS ? '...' + string?.substring(0, this.MAX_CHARS) : string;
  }

  ngOnDestroy() {
    this.onUpdateAdvancedFiltersSubscription$?.unsubscribe();
  }
}
